import { FirebaseOptions, getApps, initializeApp } from "firebase/app";

const resolveEmulatorHost = (): string => {
  const isLocalhost =
    typeof window === "undefined" ||
    ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname) ||
    window.location.hostname.endsWith(".localhost");

  const host = isLocalhost
    ? "localhost"
    : import.meta.env.VITE_FIREBASE_DOCKER_EMULATOR_HOST;

  if (!host) {
    throw new Error(
      `Failed to resolve emulator host. VITE_FIREBASE_DOCKER_EMULATOR_HOST is not set`,
    );
  }
  return host;
};

type Emulator = "auth" | "firestore" | "storage" | "functions";

const EMULATOR_PORTS: Record<Emulator, number> = {
  auth: 9099,
  firestore: 8080,
  storage: 9199,
  functions: 5001,
};

// run-stack gives each emulator its own domain on port 80, e.g. "{emulator}.reedy.local".
const resolveEmulatorAddress = (
  emulator: Emulator,
): { host: string; port: number } => {
  const hostTemplate = import.meta.env.VITE_FIREBASE_EMULATOR_HOST_TEMPLATE;

  if (hostTemplate) {
    return { host: hostTemplate.replace("{emulator}", emulator), port: 80 };
  }

  return { host: resolveEmulatorHost(), port: EMULATOR_PORTS[emulator] };
};

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true";
let AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
if (useEmulator) {
  AUTH_DOMAIN = resolveEmulatorHost();
}

const config: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const [app = initializeApp(config)] = getApps();
export { useEmulator, resolveEmulatorAddress };
